import {v4 as uuidv4} from "uuid";
import React, {useEffect, useState} from "react";
import {dateConvert} from "../../../Utils/ConvertDate";
import axios from "axios";
import config from "../../../Helpers/config.json";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import {AccountingDrawer} from "../../../Utils/AccountingUtils/AccountingDrawer";
import NewLedgerEntry from "./NewLedgerEntry";

const LedgerEntry = ({actions,isSubmitLedger, setIsSubmitLedger}) => {
    const initialState = [{
        id: uuidv4(),
        account_name: '',
        account_id: '',
        description: '',
        entry_type: '',
        debit: '',
        credit: ''
    },
        {id: uuidv4(), account_name: '', account_id: '', entry_type: '', debit: '', credit: ''}]
    const [state, setState] = useState({date: dateConvert(), notes: '',description: '',});
    const [accounts, setAccounts] = useState([]);
    const [ledger, setLedger] = useState(initialState);
    const [total, setTotal] = useState({debit_total: 0, credit_total: 0})
    const [submitted, setSubmitted] = useState(false);
    const [open, setOpen] = useState(false)



    useEffect(() => {
        axios.get(`${config.epharmUrl}/accounting/chart/journals`).then(res => {
            const data = res.data;
            const dt = data ? data : {};
            const arr = dt.data ? dt.data : []
            const list = arr.map(item => ({
                value: item.id,
                label: item.head_name
            }))
            setAccounts(list)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }, [])

    const handleChange = (event) => {
        const {value, name} = event.target;
        setState({...state, [name]: value})
    }

    // const handleChangeMemo = (event) => {
    //     const {value, name} = event.target;
    //     setMemo({...state, [name]: value})
    // }

    const handleChangeAccount = (val, id) => {
        const arr = ledger.map(item => {
            if (item.id === id) {
                return {...item, account_id: val}
            }
            return item
        })
        setLedger(arr)
    }

    const calculateTotal = (arr) => {
        const debit_total = arr.reduce((sum, item) => {
            return +sum + +item.debit;
        }, 0)
        const credit_total = arr.reduce((sum, item) => {
            return +sum + +item.credit;
        }, 0)
        setTotal({debit_total, credit_total})
    }

    const handleBlurDebit = (id) => {
        const arr = ledger.map(item => {
            if (item.id === id) {
                if (item.credit !== '' && item.debit) {
                    return {...item, credit: '', entry_type: 'DEBIT'}
                } else {
                    return item;
                }
            }
            return item
        })
        setLedger(arr);
        calculateTotal(arr)
    }
    const handleBlurCredit = (id) => {
        const arr = ledger.map(item => {
            if (item.id === id) {
                if (item.debit !== '' && item.credit) {
                    return {...item, debit: '', entry_type: 'CREDIT'}
                } else {
                    return item;
                }
            }
            return item
        })
        setLedger(arr);
        calculateTotal(arr)
    }

    const handleChangeItems = (event, id) => {
        const {value, name} = event.target;
        const arr = ledger.map(item => {
            if (item.id === id) {
                return {...item, [name]: value, entry_type: name === 'debit' ? 'DEBIT' : name === 'credit' ? 'CREDIT':''}
            }
            return item
        })
        setLedger(arr)
    }

    const addItem = () => {
        const row = {
            id: uuidv4(),
            account_name: '',
            account_id: '',
            description: '',
            entry_type: '',
            debit: '',
            credit: ''
        }
        setLedger([...ledger, row])
    }

    const removeRow = (id) => {
        const arr = ledger.filter(item => item.id !== id)
        setLedger(arr)
    }

    const handleSubmit = (event) => {
        const {date,description} = state;
        event.preventDefault();
        // const formData = new FormData();
        const ledgerData = [];

        ledger.filter(item => item.account_id.value).forEach(item => {
          const entry = {
            entry_category: item.entry_type,
            amount: item.debit ? item.debit : item.credit ? item.credit : 0
            // ... other properties if needed
          };
      
          if (item.entry_type === 'CREDIT') {
            entry.credit_ledger = item.account_id.value;
          }
      
          if (item.entry_type === 'DEBIT') {
            entry.debit_ledger = item.account_id.value;
          }
      
          ledgerData.push(entry);
        });
      
        const jsonData = {
          date_added: date,
          memo:description,
          total_amount:total.debit_total,
          ledger: ledgerData
        };
      
        const arr = ledger.every(item => item.account_id && (item.debit || item.credit));
      
        if (arr && date) {
            setIsSubmitLedger('pending');
            axios.post(`${config.epharmUrl}/accounting/journals/entry`, jsonData).then(() => {
                actions.snackbarActions.successSnackbar('Entry made successfully')
                setOpen(false)
                setIsSubmitLedger('resolved')
                const arr = ledger.map(item=>({
                    ...item,
                    id: uuidv4(),
                    account_name: '',
                    account_id: '',
                    entry_type: '',
                    debit: '',
                    credit: ''
                }))
                setState({description:''})
                setTotal({debit_total: 0, credit_total: 0})
                setLedger(arr)
                setSubmitted(false)
            }).catch(err => {
                errorMessages(err, null, actions)
                setIsSubmitLedger('rejected')
            })
        }
    }

    const handleOpenDialog = () =>{
        setOpen(true)
    }

    const handleCloseDialog = () =>{
        setOpen(false)
    }

    const ledgerProps = {
        state, accounts, ledger, handleChange, handleChangeAccount, handleChangeItems, removeRow,
        addItem, total, handleBlurCredit, handleBlurDebit, handleSubmit, isSubmitted:isSubmitLedger, submitted,
        open, handleOpenDialog, handleCloseDialog
    }



    return (
      <div>
        <div className="text-right">
          <button
            onClick={handleOpenDialog}
            data-testid="new-journal-entry-btn"
            className="btn btn-sm pharmacy-info-btn"
          >
            New Entry
          </button>
        </div>
        <AccountingDrawer
          open={open}
          title="New Ledger Entry"
          handleClose={handleCloseDialog}
        >
          <NewLedgerEntry {...ledgerProps} />
        </AccountingDrawer>
      </div>
    );
}
export default LedgerEntry